import routerOptions0 from "/app/build/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.4.1_@types+node@18.19.50_db0@0.3.2_encoding@0.1.13_eslint_c7fd73349cdb6398e0e83cf1cac8e7d9/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app/build/products/Survey/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}